import { defineStore } from 'pinia'
import TextCell from '@/onenetwork/components/datatable/TextCell.vue'
import DateTimeCell from '@/onenetwork/components/datatable/DateTimeCell.vue'
import CoordinateCell from '@/onenetwork/components/datatable/CoordinateCell.vue'
import TagCell from '@/onenetwork/components/datatable/TagCell.vue'
import { uuid } from 'vue3-uuid'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant.ts'
import RealestateAPI from '@/modules/realestate/constants/realestate.api.uri.const.ts'
import { buildFilterObject } from '@/utils/filter'
import { formatTableDataRealestate } from '../helper/table'
import { markRaw } from 'vue'

export interface tabItem {
  id: string
  label: string
  active: boolean
}

export enum AssetsListActionTypes {
  FILTERING = 'FILTERING',
  PENDING = 'PENDING',
  FETCHING = 'FETCHING',
  FETCH_SUCCESS = 'FETCH_SUCCESS',
  FETCH_FAILURE = 'FETCH_FAILURE',
}

interface AssetsListStore {
  action_type: AssetsListActionTypes
  action_mess: string
  uuid: string
  data: Object
  filter: Array<{
    key: string
    type: string
    label: string
    placeholder: string
    value: any
    options?: Array<{ label: string; value: string }>
  }>
  pageSize: number
  page: number
  tabs: Array<any>
  tableConfig: any
  selectedIds: Array<string | number>
}

export const useAssetsListStore = defineStore('assets.list', {
  state: (): AssetsListStore => ({
    action_type: AssetsListActionTypes.PENDING,
    action_mess: '',
    uuid: '',
    data: {
      list: [],
      totalRecords: 0,
      totalPage: 0,
    },
    filter: [
      {
        key: 'province_id',
        type: 'region-level-1',
        label: 'Lọc theo tỉnh/thành',
        placeholder: 'Chọn tỉnh thành',
        value: '',
        options: null,
      },
      {
        key: 'ward_id',
        type: 'region-level-2',
        label: 'Lọc theo phường / xã',
        placeholder: 'Chọn phường / xã',
        value: '',
        options: null,
      },
      {
        key: 'map_sheet_number',
        type: 'text',
        label: 'Số tờ',
        placeholder: 'Nhập số tờ',
        value: '',
      },
      {
        key: 'plot_number',
        type: 'text',
        label: 'Số thửa',
        placeholder: 'Nhập số thửa',
        value: '',
      },
      {
        key: 'keyword',
        type: 'taginput',
        label: 'Lọc theo từ khoá',
        placeholder: 'Nhập từ khoá',
        value: '',
      },
    ],
    pageSize: 10,
    page: 1,
    tabs: [
      {
        id: 'list',
        label: 'Danh sách tài sản',
        active: true,
      },
    ],
    tableConfig: {
      canShowHide: true,
      columns: {
        code: {
          label: 'ID',
          component: markRaw(TextCell),
          class: '',
          visible: true,
          sort: false,
          config: {},
        },
        land_type: {
          label: 'Loại BDS',
          component: markRaw(TagCell),
          class: '',
          visible: true,
          sort: false,
          config: {},
        },
        region_lv1: {
          label: 'Tỉnh thành',
          component: markRaw(TextCell),
          class: '',
          visible: true,
          sort: false,
          config: {},
        },
        region_lv2: {
          label: 'Phường / Xã',
          component: markRaw(TextCell),
          class: '',
          visible: true,
          sort: false,
          config: {},
        },
        area: {
          label: 'Diện tích',
          component: markRaw(TextCell),
          class: '',
          visible: true,
          sort: false,
          config: {},
        },
        map_sheet_number: {
          label: 'Số tờ',
          component: markRaw(TextCell),
          class: '',
          visible: true,
          sort: false,
          config: {},
        },
        plot_number: {
          label: 'Số thửa',
          component: markRaw(TextCell),
          class: '',
          visible: true,
          sort: false,
          config: {},
        },
        address: {
          label: 'Địa chỉ',
          component: markRaw(TextCell),
          class: '',
          visible: true,
          sort: false,
          config: {},
        },
        coords: {
          label: 'Toạ độ',
          component: markRaw(CoordinateCell),
          class: '',
          visible: true,
          sort: false,
          config: {},
        },
        fist_listing_at: {
          label: 'Ngày list lần đầu',
          component: markRaw(DateTimeCell),
          class: '',
          visible: true,
          sort: false,
          config: {},
        },
        created_at: {
          label: 'Ngày đăng ký',
          component: markRaw(DateTimeCell),
          class: '',
          visible: true,
          sort: 'desc',
          config: {},
        },
      },
    },
    selectedIds: [],
  }),
  getters: {
    sortFilter: (state) => {
      const sort: any = []
      if (Object.keys(state.tableConfig?.columns).length > 0) {
        Object.keys(state.tableConfig?.columns).forEach((col) => {
          if (state.tableConfig.columns[col].sort) {
            sort.push([col, state.tableConfig.columns[col].sort])
          }
        })
      }
      return sort
    },
  },
  actions: {
    //TAB ACTION
    changeTab(targetId: string) {
      console.log(`${targetId}`)
      for (const tab of this.tabs) {
        tab.active = tab.id === targetId
      }
    },
    closeTab(targetId: string) {
      const index = this.tabs.findIndex((tab) => tab.id === targetId)
      if (index !== -1) {
        this.tabs.splice(index, 1)
      }
    },
    closeAllTab() {
      this.tabs = [
        {
          id: 'list',
          label: 'Danh sách tài sản',
          active: true,
        },
      ]
    },
    newTab(item: tabItem) {
      const exists = this.tabs.some((tab) => tab.id === item.id)
      if (!exists) {
        this.tabs.push(item)
      }
      this.changeTab(item.id)
    },

    //FILTER ACTION
    setFilter(filter: any) {
      this.filter = filter
      this.action_type = AssetsListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },
    changeFilter(key: string, value: any) {
      const filterItem = this.filter.find((item: { key: string }) => item.key === key)
      if (filterItem) {
        filterItem.value = value
        this.action_type = AssetsListActionTypes.FILTERING
        this.uuid = uuid.v4()
      }
    },

    //PAGE ACTION
    changePage(page: number) {
      this.page = page
      this.action_type = AssetsListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },
    changePageSize(size: number) {
      this.pageSize = size
      this.action_type = AssetsListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },

    //TABLE CONFIG ACTION
    toggleColumnVisibility(columnCode: string, visible: boolean) {
      if (this.tableConfig?.columns[columnCode]) {
        this.tableConfig.columns[columnCode].visible = visible
      } else {
        console.warn(`Column "${columnCode}" không tồn tại trong tableConfig`)
      }
    },
    toggleSort(columnCode: string, sort: string) {
      if (this.tableConfig?.columns[columnCode]) {
        this.tableConfig.columns[columnCode].sort = sort
      } else {
        console.warn(`Column "${columnCode}" không tồn tại trong tableConfig`)
      }
    },

    //DATA ACTION
    async fetchList() {
      return new Promise(async (resolve, reject) => {
        try {
          this.action_type = AssetsListActionTypes.FETCHING
          const sort = this.sortFilter
          const pagination = {
            page: this.page,
            pageSize: this.pageSize,
            sort,
          }
          const res = await APIClient.get(RealestateAPI.asset.list, {
            params: buildFilterObject(this.filter, pagination),
          })

          console.log(302)
          const { data } = res.data
          console.log(304,data);
          this.data = {
            list: formatTableDataRealestate(data.data || []),
            totalRecords: data.total ?? 0,
            totalPage: data.last_page ?? 0,
          }
          console.log(307, this.data)
          this.action_type = AssetsListActionTypes.FETCH_SUCCESS
          resolve(res)
        } catch (e) {
          this.action_type = AssetsListActionTypes.FETCH_FAILURE
          reject(e)
        }
      })
    },
  },
})
